import SEO from "../components/SEO";

const Stocks = () => {
  return (
    <div className="container py-5">
       <SEO
  title="Fantasy Stocks | IPL Fantasy Style Cricket Stock Simulation app like dream11"
  description="cric10trade | Explore fantasy stocks inspired by IPL teams and player performance. Track demand, cricket score impact, and IPL match score trends while learning stock market fundamentals."
  keywords="fantasy stocks, cricket fantasy stocks, ipl fantasy stocks, cricket score impact on stocks, stock simulation platform"
  url="https://www.criconezerotrade.com/stocks"
/>
      
      <div className="row justify-content-center">
        <div className="col-md-8">
          <h2 className="fw-bold mb-4">Stocks Overview</h2>

          <div className="card mb-3 p-3 shadow-sm">
            <h5>What Are Stocks?</h5>
            <p>
              Stocks represent ownership in a company. When you buy a stock,
              you own a small portion of that company.
            </p>
          </div>

          <div className="card mb-3 p-3 shadow-sm">
            <h5>Why Learn Stocks?</h5>
            <p>
              Learning stocks helps build financial awareness, long-term
              planning, and smart investment habits.
            </p>
          </div>

          <div className="card p-3 shadow-sm">
            <h5>Fantasy Stock Concept</h5>
            <p>
              Fantasy stocks allow users to learn without financial risk by
              simulating market scenarios.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Stocks;